var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdaAvatar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.998 3.083c2.752 0 4.967 2.182 4.967 4.933 0 1.096-.28 1.812-.977 2.895l-.394.604c-.294.462-.434.742-.532 1.079.072.144.111.306.111.477v1.014c0 .507-.35.932-.82 1.047l-.208.939a1.078 1.078 0 0 1-1.052.846H8.9c-.506 0-.944-.353-1.052-.847l-.207-.938a1.08 1.08 0 0 1-.82-1.047v-1.014c0-.17.04-.332.11-.475l.015.044c-.1-.36-.24-.647-.553-1.137l-.251-.384C5.346 9.916 5.03 9.181 5.03 8.016c0-2.751 2.215-4.933 4.968-4.933z",
  fill: "#0481A0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E9E9E9",
  d: "M11.151 15.912H8.843l-.255-1.163h2.82zm-3.324-1.754h4.342v-1.16H7.827z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.998 4.088c-2.189 0-3.963 1.723-3.963 3.928 0 1.916 1.428 2.714 1.88 4.357h4.165c.453-1.643 1.88-2.441 1.88-4.357 0-2.205-1.774-3.928-3.962-3.928z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.998 4.634c-1.902 0-3.417 1.493-3.417 3.382 0 .782.213 1.278.855 2.247l.062.094c.412.622.646 1.021.81 1.46l.004.01h3.37l.005-.01c.148-.395.353-.758.692-1.28l.118-.18.014-.02.049-.074c.641-.97.855-1.465.855-2.247 0-1.89-1.516-3.382-3.417-3.382z",
  fill: "#FDFFAB",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.998 5.544c-1.402 0-2.507 1.089-2.507 2.472 0 .557.153.912.704 1.745l.062.094c.27.408.473.733.634 1.04l.01.022h2.192l.012-.022c.133-.256.297-.524.504-.843l.13-.197.062-.094c.55-.833.704-1.188.704-1.745 0-1.383-1.105-2.472-2.507-2.472z",
  fill: "#FF0",
  fillRule: "nonzero"
})))));
export default SvgAdaAvatar;